import { getLocale } from "../runtime";

const sv_resetfilters = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Återställ filter`
};

const resetfilters = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_resetfilters(inputs)
	return "resetFilters";
};

export { resetfilters as "resetFilters" };